import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import { ModalContainer, ModalDialog } from 'react-modal-dialog';
import { browserHistory } from 'react-router';
// Components
import Item from '../../layout/sui/item/Item';
import CloseButton from '../../layout/closeButton/CloseButton';

const propTypes = {
  locale: PropTypes.string,
  mediaDetails: PropTypes.object.isRequired,
};

const MediaPartnerDetails = (props) => {
  const {
    name,
    site,
    facebook,
    twitter,
    resume,
    scope,
    language,
    themes,
    locale,
  } = props.mediaDetails;

  const image = `https://admin.futurecom.com.br/uploads/media_partner/${props.mediaDetails.image}`;

  const handleClose = () => {
    browserHistory.goBack();
  };

  const description = (
    <div style={{ textAlign: 'left' }}>
      <div className="ui icon buttons">
        {
          site &&
            <a href={`http://${site}`} className="ui button">
              <i className="world bookmark icon" />
            </a>
        }
        {
          facebook &&
            <a href={`http://${facebook}`} className="ui facebook button">
              <i className="ui facebook icon" />
            </a>
        }
        {
          twitter &&
            <a href={`http://${twitter}`} className="ui twitter button">
              <i className="twitter icon" />
            </a>
        }
      </div>
      {
        props.locale === 'pt' &&
          <div>
            <div className="ui divider" />
            <h3 className="ui header">
              <FormattedMessage
                id="description"
                description="Description tag"
                defaultMessage="Description"
              />
            </h3>
            <p>{resume}</p>
            <h3 className="ui header">
              <FormattedMessage
                id="scope"
                description="Scope tag"
                defaultMessage="Scope"
              />
            </h3>
            <p>{scope}</p>
            <h3 className="ui header">
              <FormattedMessage
                id="language"
                description="Language tag"
                defaultMessage="Language"
              />
            </h3>
            <p>{language}</p>
            <h3 className="ui header">
              <FormattedMessage
                id="themes"
                description="Themes tag"
                defaultMessage="Themes"
              />
            </h3>
            <p>{themes}</p>
            <h3 className="ui header">
              <FormattedMessage
                id="locale"
                description="Locale tag"
                defaultMessage="Locale"
              />
            </h3>
            <p>{locale}</p>
          </div>
      }
    </div>
  );

  return (
    <ModalContainer onClose={handleClose}>
      <ModalDialog onClose={handleClose}>
        <div style={{ textAlign: 'left' }}>
          <div className="ui container">
            <div className="ui segment">
              <div className="ui items">
                <Item
                  image={image}
                  alt={name}
                  size="small"
                  header={name}
                  description={description}
                />
              </div>
            </div>
            <CloseButton handleClose={handleClose} />
          </div>
        </div>
      </ModalDialog>
    </ModalContainer>
  );
};

MediaPartnerDetails.propTypes = propTypes;

export default MediaPartnerDetails;



/** WEBPACK FOOTER **
 ** ./src/components/screens/mediaPartners/MediaPartnerDetails.js
 **/